<template>
    <div>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="550px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-on:close="handleCancel"
        >
            <div style="display: flex">
                <i class="el-icon-info warn-blue"></i>
                <div>
                    <div class="dialog-content">
                        <p v-if="$util.isEmpty(riskLevel)">
                            暂无可沿用的历史风险测评结果，请先完成风险测评。
                        </p>
                        <p v-else>
                            {{
                                `您上一次风险测评结果为：【${$cache.getDict(
                                    "100017",
                                    riskLevel
                                )}】。确认沿用该结果作为本次风险测评结果吗？`
                            }}
                        </p>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button v-if="!$util.isEmpty(riskLevel)" class="btn" v-on:click="handleCancel">
                    取消
                </el-button>
                <el-button class="btn" type="primary" v-on:click="handleConfirm">
                    {{!$util.isEmpty(riskLevel) ? "确认沿用" : "我知道了"}}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "LastRiskConfirm",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        riskLevel: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            dialogVisible: false
        };
    },
    computed: {
        title() {
            return this.$util.isEmpty(this.riskLevel) ? "提示" : "风险测评结果确认";
        }
    },
    watch: {
        visible(newVal) {
            this.dialogVisible = newVal;
        }
    },
    methods: {
        handleCancel() {
            this.resetState();
            this.$emit("cancel");
        },
        handleConfirm() {
            this.resetState();
            this.$emit("confirm", !this.$util.isEmpty(this.riskLevel));
        },
        resetState() {
            this.dialogVisible = false;
        }
    }
};
</script>

<style scoped>
.dialog-content {
    color: var(--color-text-primary);
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
}
.warn-blue {
    color: var(--color-primary);
    font-size: 18px;
    margin: 2px 4px 0 0;
}
:deep(.el-dialog__header) {
    background: var(--color-divided);
}
:deep(.el-dialog__footer) {
    text-align: center;
}
.btn {
    width: 160px;
}
</style>
